import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function ForceChangePasswordPage() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 12) return toast.error("كلمة المرور يجب أن تكون 12 حرفًا فأكثر");
        if (password !== confirm) return toast.error("تأكيد كلمة المرور لا يطابق");
        setSaving(true);
        try {
            await api.post("/auth/force-change-password", { new_password: password, confirm_new_password: confirm });
            toast.success("تم تحديث كلمة المرور. سجّل الدخول بها مجددًا.");
            await logout();
            navigate("/login");
        } catch (e) { toast.error(formatError(e.response?.data?.detail) || e.message); }
        finally { setSaving(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 public-scope">
            <div className="w-full max-w-md bg-white rounded-sm border border-gray-200 shadow-sm p-8">
                <div className="flex items-center justify-center gap-2 mb-4 text-brand-red"><ShieldCheck className="w-8 h-8" /></div>
                <h1 className="font-display font-black text-2xl mb-1 text-brand-black text-center">تعيين كلمة مرور دائمة</h1>
                <p className="text-sm text-gray-500 mb-6 text-center">لأمانك، يجب تعيين كلمة مرور جديدة تختلف عن الكلمة المؤقتة قبل الدخول للوحة التحكم.</p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <Label className="mb-1 block">كلمة المرور الجديدة (12 حرفًا فأكثر)</Label>
                        <Input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-sm" data-testid="force-new-password" />
                    </div>
                    <div>
                        <Label className="mb-1 block">تأكيد كلمة المرور</Label>
                        <Input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="rounded-sm" data-testid="force-confirm-password" />
                    </div>
                    <Button type="submit" disabled={saving} className="w-full bg-brand-red hover:bg-brand-red-dark rounded-sm" data-testid="force-submit">
                        {saving ? "جارٍ الحفظ..." : "حفظ وتسجيل الدخول"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
